"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[605],{

/***/ 3601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BreadCrumb_BreadCrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/assets/svg/breadcrumb_arrow.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.735073 8.99938C0.924127 8.99938 1.11306 8.9236 1.2568 8.77149L4.78616 5.04303C5.071 4.7426 5.071 4.25676 4.78616 3.95597L1.2568 0.22732C0.970702 -0.07508 0.505042 -0.0767 0.21688 0.22354C-0.0711648 0.523612 -0.0728838 1.01234 0.213334 1.31438L3.22816 4.4994L0.213334 7.68443C-0.0728838 7.98684 -0.0711648 8.4752 0.21688 8.77545C0.360277 8.92486 0.547729 8.99938 0.735073 8.99938Z",
  fill: "#969696"
});

function SvgBreadcrumbArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var breadcrumb_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgNSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNzM1MDczIDguOTk5MzhDMC45MjQxMjcgOC45OTkzOCAxLjExMzA2IDguOTIzNiAxLjI1NjggOC43NzE0OUw0Ljc4NjE2IDUuMDQzMDNDNS4wNzEgNC43NDI2IDUuMDcxIDQuMjU2NzYgNC43ODYxNiAzLjk1NTk3TDEuMjU2OCAwLjIyNzMyQzAuOTcwNzAyIC0wLjA3NTA4IDAuNTA1MDQyIC0wLjA3NjcgMC4yMTY4OCAwLjIyMzU0Qy0wLjA3MTE2NDggMC41MjM2MTIgLTAuMDcyODgzOCAxLjAxMjM0IDAuMjEzMzM0IDEuMzE0MzhMMy4yMjgxNiA0LjQ5OTRMMC4yMTMzMzQgNy42ODQ0M0MtMC4wNzI4ODM4IDcuOTg2ODQgLTAuMDcxMTY0OCA4LjQ3NTIgMC4yMTY4OCA4Ljc3NTQ1QzAuMzYwMjc3IDguOTI0ODYgMC41NDc3MjkgOC45OTkzOCAwLjczNTA3MyA4Ljk5OTM4WiIgZmlsbD0iIzk2OTY5NiIvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/BreadCrumb.tsx









function BreadCrumb({
  breadCrumbs
}) {
  const siteName = (0,hooks/* useSettingItem */.qT)('WEBSITE_NAME');
  const breadCrumbList = [];

  if (siteName) {
    breadCrumbList.push({
      label: siteName,
      url: '/'
    });
  }

  if (breadCrumbs) {
    breadCrumbList.push(...breadCrumbs);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: (breadCrumbList !== null && breadCrumbList !== void 0 ? breadCrumbList : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
      children: [breadCrumbList.length === index + 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: item.label
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: item.url,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: item.label
        })
      }), !(breadCrumbList.length === index + 1) && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgBreadcrumbArrow, {})]
    }, index))
  });
}

const Component = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "BreadCrumb__Component",
  componentId: "sc-16duxws-0"
})(["margin-bottom:3px;padding-bottom:3px;white-space:nowrap;overflow:auto;display:flex;align-items:center;margin-top:15px;svg{margin:0 9px;}&::-webkit-scrollbar{-webkit-appearance:none;height:1px;}&::-webkit-scrollbar-thumb{position:absolute;top:0;border-radius:4px;background-color:", ";}"], theme/* colors.grayLighter */.O9.grayLighter);
const Inner = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BreadCrumb__Inner",
  componentId: "sc-16duxws-1"
})(["display:flex;align-items:center;"]);
const Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BreadCrumb__Label",
  componentId: "sc-16duxws-2"
})(["font-style:normal;font-weight:500;font-size:10px;line-height:18px;color:#7e7e7e;"]);
/* harmony default export */ var BreadCrumb_BreadCrumb = (BreadCrumb);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/index.ts


/***/ }),

/***/ 15860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CatalogCard_CatalogCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./src/components/ProductCard/ProductCard.constants.ts
var ProductCard_constants = __webpack_require__(63181);
// EXTERNAL MODULE: ./src/typings/model.ts
var model = __webpack_require__(77771);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Cards/CatalogCard/CatalogCardView.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















function CatalogCardView({
  params,
  data
}) {
  var _data$name, _data$subtitle;

  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PictureWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureImage */.iS)(data === null || data === void 0 ? void 0 : data.image)))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionTop, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
          children: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : ''
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle, {
          children: (_data$subtitle = data === null || data === void 0 ? void 0 : data.subtitle) !== null && _data$subtitle !== void 0 ? _data$subtitle : ''
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceWrapper, {
        children: data !== null && data !== void 0 && data.discountPrice && data.price !== data.discountPrice ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [(data === null || data === void 0 ? void 0 : data.price) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Price, {
            hasDiscount: true,
            children: [(0,common/* normalizePrice */.nQ)(data.price), " ", currency]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Price, {
            isBlack: true,
            children: [(0,common/* normalizePrice */.nQ)(data.discountPrice), " ", currency]
          })]
        }) : data !== null && data !== void 0 && data.price ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Price, {
          isBlack: true,
          children: [(0,common/* normalizePrice */.nQ)(data.price), " ", currency]
        }) : null
      }), data !== null && data !== void 0 && data.availability ? /*#__PURE__*/(0,jsx_runtime.jsx)(Avalability, {
        type: data.availability,
        children: (0,ProductCard_constants/* convertLabel */.T)(t, data.availability)
      }) : null]
    }), !!(params !== null && params !== void 0 && params.length) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Fields, {
      children: params.map((field, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(FieldSection, {
        sizeParams: field.name === 'SIZE',
        children: field.data.length > 0 && field.data.map((param, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(FieldItemWrapper, {
          sizeParams: field.name === 'SIZE',
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FieldName, {
            children: param.name
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(FieldValue, {
            children: param.value
          })]
        }, index))
      }, index))
    }) : null]
  });
}

/* harmony default export */ var CatalogCard_CatalogCardView = (CatalogCardView);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__Component",
  componentId: "sc-1ek1tz1-0"
})([""]);
const PictureWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__PictureWrapper",
  componentId: "sc-1ek1tz1-1"
})(["padding:5px 0;"]);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "CatalogCardView__StyledPicture",
  componentId: "sc-1ek1tz1-2"
})(["height:120px;width:100%;picture,div,img{height:100%;width:100%;object-fit:contain;object-position:left;}"]);
const DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__DescriptionWrapper",
  componentId: "sc-1ek1tz1-3"
})(["display:flex;flex-direction:column;justify-content:space-between;margin-top:5px;height:100px;& > div{margin-top:5px;}"]);
const DescriptionTop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__DescriptionTop",
  componentId: "sc-1ek1tz1-4"
})([""]);
const Name = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__Name",
  componentId: "sc-1ek1tz1-5"
})(["font-style:normal;font-weight:500;font-size:14px;line-height:24px;"]);
const Subtitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__Subtitle",
  componentId: "sc-1ek1tz1-6"
})(["font-size:12px;font-weight:500;line-height:18px;color:rgb(168,168,168);"]);
const PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__PriceWrapper",
  componentId: "sc-1ek1tz1-7"
})(["max-width:460px;display:flex;align-items:center;& > div:not(:last-child){margin-right:15px;}"]);
const Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__Price",
  componentId: "sc-1ek1tz1-8"
})(["", ""], ({
  hasDiscount,
  hasDiscountPLus,
  isBlack
}) => hasDiscount && !hasDiscountPLus ? (0,styled_components_browser_esm.css)(["font-style:normal;line-height:20px;text-decoration-line:line-through;font-weight:500;font-size:14px;color:", ";"], theme/* colors.darkGrey */.O9.darkGrey) : hasDiscount && hasDiscountPLus ? (0,styled_components_browser_esm.css)(["font-style:normal;line-height:26px;font-weight:600;font-size:18px;text-decoration-line:line-through;color:", ";"], theme/* colors.black */.O9.black) : (0,styled_components_browser_esm.css)(["font-style:normal;line-height:26px;font-weight:600;font-size:22px;color:", ";"], !isBlack ? theme/* colors.primary */.O9.primary : theme/* colors.black */.O9.black));
const Avalability = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__Avalability",
  componentId: "sc-1ek1tz1-9"
})(["margin-top:auto;font-size:14px;font-weight:500;", ""], ({
  type
}) => type === model/* AvailabilityStatus.AVAILABLE */.p.AVAILABLE ? (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.green */.O9.green) : type === model/* AvailabilityStatus.ON_REQUEST */.p.ON_REQUEST ? (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.red */.O9.red) : type === model/* AvailabilityStatus.OUT_OF_ORDER */.p.OUT_OF_ORDER ? (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.gray300 */.O9.gray300) : (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.black */.O9.black));
const Fields = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__Fields",
  componentId: "sc-1ek1tz1-10"
})(["margin-top:10px;padding:10px 0;border-top:1px solid ", ";"], theme/* colors.gray100 */.O9.gray100);
const FieldSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__FieldSection",
  componentId: "sc-1ek1tz1-11"
})(["", " &:not(:first-child){margin-top:10px;}"], ({
  sizeParams
}) => sizeParams ? (0,styled_components_browser_esm.css)(["display:flex;align-items:center;& > div:not(:first-child){margin-left:16px;}"]) : null);
const FieldItemWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCardView__FieldItemWrapper",
  componentId: "sc-1ek1tz1-12"
})(["", ""], ({
  sizeParams
}) => sizeParams ? (0,styled_components_browser_esm.css)(["display:flex;flex-direction:column;"]) : null);
const FieldName = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CatalogCardView__FieldName",
  componentId: "sc-1ek1tz1-13"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.gray400 */.O9.gray400);
const FieldValue = styled_components_browser_esm["default"].span.withConfig({
  displayName: "CatalogCardView__FieldValue",
  componentId: "sc-1ek1tz1-14"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.black */.O9.black);
;// CONCATENATED MODULE: ./src/components/Cards/CatalogCard/CatalogCard.tsx








function CatalogCard({
  data
}) {
  const t = (0,production/* useTranslations */.T_)();
  const paramsFiltered = (0,react.useMemo)(() => {
    const brandList = [];
    const sizeList = [];

    if (!data) {
      return [];
    }

    if (data !== null && data !== void 0 && data.brand) {
      brandList.push({
        name: t('manufacturer'),
        value: data.brand
      });
    }

    if (data !== null && data !== void 0 && data.fields) {
      data.fields.forEach(field => {
        if (field.name === 'MEHANIZM-TRANSFORMACII') {
          brandList.push({
            name: field.label,
            value: field.value
          });
        } else {
          sizeList.push({
            name: field.label,
            value: field.value
          });
        }
      });
    }

    return [{
      name: 'BRAND',
      data: brandList
    }, {
      name: 'SIZE',
      data: sizeList
    }];
  }, [data]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogCard_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CatalogCard_CatalogCardView, {
        data: data,
        params: paramsFiltered !== null && paramsFiltered !== void 0 ? paramsFiltered : []
      })
    })
  });
}

/* harmony default export */ var CatalogCard_CatalogCard = (CatalogCard);
const CatalogCard_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CatalogCard__Component",
  componentId: "sc-1ewebm8-0"
})(["border:1px solid ", ";padding:2px 0;"], theme/* colors.gray100 */.O9.gray100);
;// CONCATENATED MODULE: ./src/components/Cards/CatalogCard/index.ts


/***/ }),

/***/ 89875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Pagination_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/rc-pagination/es/index.js + 18 modules
var es = __webpack_require__(66455);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
;// CONCATENATED MODULE: ./src/assets/svg/NextArrow.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.39999 8.8999L1.19999 15.1999C0.799988 15.5999 0.799988 16.1999 1.19999 16.5999C1.59999 16.9999 2.19999 16.9999 2.59999 16.5999L9.49999 9.5999C9.89999 9.1999 9.89999 8.5999 9.49999 8.1999L2.59999 1.1999C2.39999 0.999902 2.19999 0.899902 1.89999 0.899902C1.59999 0.899901 1.39999 0.999902 1.19999 1.1999C0.799989 1.5999 0.799989 2.1999 1.19999 2.5999L7.39999 8.8999Z",
  fill: "black"
});

function SvgNextArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var NextArrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjM5OTk5IDguODk5OUwxLjE5OTk5IDE1LjE5OTlDMC43OTk5ODggMTUuNTk5OSAwLjc5OTk4OCAxNi4xOTk5IDEuMTk5OTkgMTYuNTk5OUMxLjU5OTk5IDE2Ljk5OTkgMi4xOTk5OSAxNi45OTk5IDIuNTk5OTkgMTYuNTk5OUw5LjQ5OTk5IDkuNTk5OUM5Ljg5OTk5IDkuMTk5OSA5Ljg5OTk5IDguNTk5OSA5LjQ5OTk5IDguMTk5OUwyLjU5OTk5IDEuMTk5OUMyLjM5OTk5IDAuOTk5OTAyIDIuMTk5OTkgMC44OTk5MDIgMS44OTk5OSAwLjg5OTkwMkMxLjU5OTk5IDAuODk5OTAxIDEuMzk5OTkgMC45OTk5MDIgMS4xOTk5OSAxLjE5OTlDMC43OTk5ODkgMS41OTk5IDAuNzk5OTg5IDIuMTk5OSAxLjE5OTk5IDIuNTk5OUw3LjM5OTk5IDguODk5OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=");

// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Pagination/Pagination.tsx








function Pagination({
  onChange,
  count,
  pageSize,
  current,
  className
}) {
  const {
    0: offSetTop,
    1: setOffsetTop
  } = (0,react.useState)(0);
  const {
    0: offSetTopClient,
    1: setOffsetTopClient
  } = (0,react.useState)(0);
  const ref = (0,react.useRef)(null);

  const onPageChange = page => {
    if (ref.current) {
      setOffsetTop(ref.current.offsetTop);
      setOffsetTopClient(ref.current.getBoundingClientRect().top);
    }

    onChange(page);
  };

  (0,react.useEffect)(() => {
    const domNode = ref.current;

    if (!domNode) {
      return;
    }

    if (offSetTop === 0) {
      return;
    }

    const nodeOffsetTopCurrent = domNode.offsetTop;

    if (nodeOffsetTopCurrent !== offSetTop) {
      (0,web_core_esm.isBrowser)() && window.scroll({
        top: domNode.offsetTop - (domNode.getBoundingClientRect().height + offSetTopClient - 40)
      });
    }
  });
  (0,react.useEffect)(() => {
    if (ref.current) {
      var _ref$current$querySel, _ref$current$querySel2;

      (_ref$current$querySel = ref.current.querySelector('.rc-pagination-next')) === null || _ref$current$querySel === void 0 ? void 0 : _ref$current$querySel.setAttribute('title', '');
      (_ref$current$querySel2 = ref.current.querySelector('.rc-pagination-prev')) === null || _ref$current$querySel2 === void 0 ? void 0 : _ref$current$querySel2.setAttribute('title', '');
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
      className: "pagination",
      nextIcon: true,
      current: current,
      hideOnSinglePage: true,
      pageSize: pageSize,
      onChange: onPageChange,
      showSizeChanger: false,
      total: count,
      showLessItems: true
    })
  });
}

/* harmony default export */ var Pagination_Pagination = (Pagination);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Pagination__Component",
  componentId: "sc-1onxtng-0"
})(["padding:5px 0;.rc-pagination{display:flex;align-items:center;justify-content:center;& > li:not(:first-child){margin-left:10px;}}.rc-pagination-prev,.rc-pagination-next,.rc-pagination-item{position:relative;cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid ", ";}.rc-pagination-prev:after{content:url(", ");position:absolute;left:calc(50% + 1px);top:calc(50% - 1px);transform:translate(-50%,-50%) rotate(180deg);}.rc-pagination-next:after{content:url(", ");position:absolute;left:50%;top:calc(50% + 1px);transform:translate(-50%,-50%);}.rc-pagination-item{color:", ";border-radius:5px;}.rc-pagination-disabled{border:1px solid ", ";}.rc-pagination-item-active{background:", ";color:", ";}.rc-pagination-jump-prev,.rc-pagination-jump-next{display:none;}"], theme/* colors.gray70 */.O9.gray70, NextArrow, NextArrow, theme/* colors.black */.O9.black, theme/* colors.gray100 */.O9.gray100, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/components/Pagination/index.ts


/***/ }),

/***/ 35635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24403);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






function ErrorPage({
  statusCode,
  title,
  isInitProps,
  errorId,
  err
}) {
  if (!isInitProps && !errorId && err) {
    // getInitialProps is not called in case of
    // https://github.com/zeit/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
  }

  const errorCode = statusCode !== null && statusCode !== void 0 ? statusCode : 500;
  const errorName = err !== null && err !== void 0 && err.name ? err.name.replace(/\.$/, '') : title !== null && title !== void 0 ? title : 'JavaScript Error';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
    title: "An error occurred",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .ErrorModule */ .TW, {
      errorCode: errorCode,
      errorName: errorName,
      errorId: errorId
    })
  });
}

ErrorPage.getInitialProps = async pageContext => {
  const {
    res,
    err,
    asPath
  } = pageContext;
  const errorInitialProps = await next_error__WEBPACK_IMPORTED_MODULE_1__["default"].getInitialProps(pageContext); // Workaround for https://github.com/zeit/next.js/issues/8592, mark when
  // getInitialProps has run

  errorInitialProps.isInitProps = true;

  if (res) {
    // Running on the server, the response object is available.
    //
    // Next.js will pass an err on the server if a page's `getInitialProps`
    // threw or returned a Promise that rejected
    if (res.statusCode === 404) {
      // Opinionated: do not record an exception in Sentry for 404
      return {
        statusCode: 404
      };
    }

    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } else {
    // Running on the client (browser).
    //
    // Next.js will provide an err if:
    //
    //  - a page's `getInitialProps` threw or returned a Promise that rejected
    //  - an exception was thrown somewhere in the React lifecycle (render,
    //    componentDidMount, etc) that was caught by Next.js's React Error
    //    Boundary. Read more about what types of exceptions are caught by Error
    //    Boundaries: https://reactjs.org/docs/error-boundaries.html
    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } // If this point is reached, getInitialProps was called without any
  // information about what the error might be. This is unexpected and may
  // indicate a bug introduced in Next.js, so record it in Sentry


  errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(new Error(`_error.js getInitialProps missing data at path: ${asPath}`));
  return errorInitialProps;
};

/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);

/***/ }),

/***/ 26625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getSharedThunkList; }
/* harmony export */ });
/* harmony import */ var _store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67463);
/* harmony import */ var _store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35439);
/* harmony import */ var _store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13006);
/* harmony import */ var _store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44272);




function getSharedThunkList(dispatch) {
  return [dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('top')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('main')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('footer')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('catalog')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('TOP')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('NEW')), dispatch((0,_store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__/* .getSettingItemListThunk */ .rT)()), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getCatalogMenuThunk */ .ke)()), dispatch((0,_store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__/* .getBlogPostListThunk */ .R3)())];
}

/***/ })

}]);